var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.debug)?_c('div',{staticClass:"wfs-map-layer"},[_c('p',[_c('strong',[_vm._v("URL: ")]),_vm._v(_vm._s(_vm.url))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }